import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker, useIntersectionObserver } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';

import * as APIS from "../../utils/service";


export default function Agree1({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [Desc, setDesc] = useState(0);   
   
    useEffect(() => {
        listopen();
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            type: 1
        }
        APIS.postData('/term', sender).then(({ data }) => {
            //console.log(data);
            setDesc(data);
        }).catch((e) => {
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });             
    }
    return(
        <Layout header={false} actives={''}>
            <div className='customercenter'>
                <div className='customercenterPage' style={{ borderRadius: 20 }}>
                    <div className='fontsize24 bolds'>이용약관</div>
                    <div>
                        <div 
                            dangerouslySetInnerHTML={{__html: Desc}}
                            className='termContetns' 
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

